import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useRoomList() {
    const { t } = useI18nUtils()
    const tableColumns = [
        { key: '', label: '', sortable: false },
        { key: 'path', label: t('cover_image'), sortable: false, tdClass:'width-200 p-1' },
        { key: 'title', label: 'Room Name', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false },
    ]
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const refRoomListTable = ref(null);
    const perPage = ref(10)
    const totalRooms = ref(0)
    const searchQuery = ref('')
    const rooms = ref([]);
    const currentPage = ref(1)
    const statusFilter = ref(null)
    const isRoomFormSidebarActive = ref(false)
    const roomData = ref(null)
    const toast = useToast()
    const dataMeta = computed(() => {
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(
            totalRooms.value,
            perPage.value * currentPage.value
        );
        return {
            from,
            to,
            of: totalRooms.value,
        }
    })

    const updateRoomsOrdering = () => {
        const filteredData = rooms.value?.filter(item => item !== undefined);

        store.dispatch('app-room/updateOrdering', filteredData)
    }

    const coverImage = (files) => {
        for(const file of files){
            if(file.is_feature) return file.path
        }
    }

    const resolveRoomStatusVariant = status =>{
        if (status) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveRoomStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const refetchData = () => {
        fetchData()
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchData()
    })

    const updateRoom = (data) => {
        roomData.value = data
        isRoomFormSidebarActive.value = true
    }

    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store.dispatch(`app-room/getRooms`, {
            limit: perPage.value,
            offset: offset,
            keywords: searchQuery.value,
            order_by: 'ordering_count DESC',
            sites_id: getLocalSite.id
        })
        .then(response => {
            rooms.value = response.data.data
            totalRooms.value = response.data.total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error fetching Room' list",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const deleteData = (id) => {
        store.dispatch('app-room/deleteRoom',id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })
            fetchData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Food Category",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        tableColumns,
        refRoomListTable,
        perPage,
        totalRooms,
        searchQuery,
        dataMeta,
        fetchData,
        resolveRoomStatusnameVariant,
        resolveRoomStatusVariant,
        rooms,
        currentPage,
        statusFilter,
        refetchData,
        updateRoom,
        isRoomFormSidebarActive,
        t,
        roomData,
        deleteData,
        coverImage,
        updateRoomsOrdering,
    }
}